<template>
  <b-row class="px-sm-4 px-md-4 px-lg-0 pt-sm-3">
    <b-col cols="12">
      <PageTitle title="Custo de Produtos" />
    </b-col>
    <b-col cols="12" class="mb-4">
      Permite visualizar e alterar os preços de custo dos produtos
    </b-col>

    <b-col cols="12 mt-4">
      <h3 class="title font-weight-bold">Filtros</h3>
    </b-col>
    
    <b-col cols="12" class="mt-2 mb-2">
      <PeriodsFilters
      ref="periodsFilters"
      :setDatesAutomatic="false"
      :startDate.sync="startDate"
      :endDate.sync="endDate"
      :limparDados="limpar"
      @click.native="filterDate()"
      />
    </b-col>

    <b-col cols="12" class="mt-5">
      <input
      @keyup.enter="get()"
      type="text"
      class="form-control"
      v-model="filters.name"
      placeholder="Nome do produto, código de barras, marca"
      />
    </b-col>

    <b-col cols="12" class="mt-3">
      <b-button variant="success" @click="get()" :disabled="loading">
        <i class="fas fa-search mr-2"></i>
        Pesquisar
      </b-button>

      <b-button variant="warning" class="ml-2" @click="cleanSelection()">
        <i class="fas fa-trash mr-2"></i>
        Limpar
      </b-button>
    </b-col>

    <b-col class="mt-4 mb-2">
      <h3 class="title font-weight-bold">
        Encontrado {{ pagination.total }} produto(s) selecionado(s) no total
      </h3>
    </b-col>

    <b-col cols="12" style="padding-bottom: 50px;">
      <b-table
        striped
        bordered
        hover
        thead-class
        show-empty
        responsive
        fixed
        empty-text="Sem produtos encontrados"
        :fields="table.headers"
        :items="table.records"
      >
        <template #table-busy>
          <div class="text-center my-2">
            <b-spinner class="align-middle mr-2"></b-spinner>
            <strong>Carregando...</strong>
          </div>
        </template>

        <template #cell(priceSalesFormat1)="data">
          <span>{{ formatNumber(data.item.priceSalesFormat1) }}</span>
          <span
            v-if="data.item.priceRule.length > 0"
            class="btn btn-dark btn-sm cursor-pointer ml-1"
            v-b-tooltip.hover
            :title="formattedPriceRules(data.item.priceRule)"
          >
            <i class="fas fa-info-circle"></i>
          </span>
        </template>

        <template #cell(photo)="data">
          <span
            @click="
              data.item.photo && showModal(data.item.productId, data.item.product, typeProducts, data.item.selectedAt)
            "
          >
            <img
              :src="data.item.photo ? linkFotos(data.item.origem) + data.item.photo : require('@/assets/img/product-placeholder.jpg')"
              :alt="data.item.product"
              class="imgWidth"
            />
          </span>
        </template>

        <template #cell(product)="data">
          <span class="spanProduct">
            {{ data.item.product }}
          </span>
        </template>

        <template #cell(costPrice)="data">
          <span class="spanProduct">
            {{ formatNumber(data.item.cost_price) }}
          </span>
        </template>

        <template #cell(taxRate)="data">
          <span class="spanProduct">
           {{ data.item.tax_rate }} %
          </span>
        </template>

        <template #cell(profit)="data">
          <span class="spanProduct">
            {{ formatNumber(calcProfit(data.item, 'pix')) }}
          </span>
        </template>

        <template #cell(percentage)="data">
          <span class="spanProduct">
            {{ calcProfit(data.item, 'pixPercentage') }} %
          </span>
        </template>

        <template #cell(actions)="data">
          <b-col cols="12" md="12" class="mb-2">
            <b-button
              variant="primary"
              size="sm"
              title="Exibir/Editar Produto"
              v-b-tooltip.hover
               @click="showPercentageModal(data.item)"
            >
              <i class="fas fa-edit"></i>
            </b-button>
          </b-col>
        </template>
      </b-table>
    </b-col>

    <b-col cols="12" class="d-flex align-items-center justify-content-center">
      <b-pagination
        v-model="pagination.currentPage"
        :total-rows="pagination.total"
        :per-page="pagination.itemsPerPage"
        :disabled="loading"
      ></b-pagination>
    </b-col>

    <percentage-partner-modal 
      ref="percentagePartnerModal"
      @save="save($event)"
    />
  </b-row>
</template>

<script>
import { mapActions, mapState } from 'vuex';
import UserTypes from '@/enums/UserTypes';
import ProductsFilters from './ProductsFilters.vue';
import PageTitle from '../../../components/PageTitle.vue';
import makeToast from '../../../mixins/makeToast';
import PeriodsFilters from '../../../components/Inputs/PeriodsFilters.vue';
import { calculateProfit } from '@/enums/TaxIugu';
import PercentagePartnerModal from '@/components/partner/PercentagePartnerModal.vue';
import shopkeeperAppApi from '@/api/shopkeeperAppApi';

export default {
  name: 'CostPriceProducts',
  mixins: [makeToast],
  components: {
    ProductsFilters,
    PageTitle,
    PeriodsFilters,
    PercentagePartnerModal
  },
  data() {
    return {
      url: '',
      filters: {},
      startDate: '',
      endDate: '',
      loading: false,
      limpar: false,
      pagination: {
        currentPage: 1,
        itemsPerPage: 1,
        total: 1,
        lastPage: 1
      },
      urlImagem: '',
      tipo: '',
      descricao: '',
      table: {
        headers: [
          {
            key: 'index',
            thClass: 'd-none',
            tdClass: 'd-none',
          },
          {
            key: 'productId',
            thClass: 'd-none',
            tdClass: 'd-none',
          },
          {
            key: 'photo',
            label: 'Detalhes',
            sortable: false,
            thClass: 'text-center fs-14',
            tdClass: 'text-center',
            thStyle: 'width: 80px;',
            tdStyle: 'width: 80px;',
          },
          {
            key: 'product',
            label: 'Produto',
            sortable: false,
            thClass: 'fs-14',
          },
          {
            key: 'codbar',
            label: 'Cod. barras',
            thClass: 'fs-14 d-none d-lg-table-cell',
            tdClass: "d-none d-lg-table-cell",
            headerClass: "d-none d-lg-table-cell", 
            sortable: false,
            thStyle: 'width: 130px'
          },
          {
            key: 'costPrice',
            label: 'Valor de Custo',
            sortable: true,
            thClass: 'text-center fs-14',
            tdClass: 'text-center ',
            thStyle: 'width: 150px'
          },
          {
            key: 'priceSalesFormat1',
            label: 'Preço de Venda',
            sortable: true,
            thClass: 'text-center fs-14',
            tdClass: 'text-center ',
            thStyle: 'width: 150px'
          },
          {
            key: 'taxRate',
            label: 'Taxa de Imposto',
            sortable: true,
            thClass: 'text-center fs-14',
            tdClass: 'text-center ',
            thStyle: 'width: 100px'
          },
          {
            key: 'profit',
            label: 'Lucro(pix)',
            sortable: true,
            thClass: 'text-center fs-14',
            tdClass: 'text-center ',
            thStyle: 'width: 150px'
          },
          {
            key: 'percentage',
            label: 'Lucro(pix) em %',
            sortable: true,
            thClass: 'text-center fs-14',
            tdClass: 'text-center ',
            thStyle: 'width: 150px'
          },
          {
            key: 'actions',
            label: 'Ações',
            sortable: false,
            thClass: 'text-center fs-14',
            tdClass: 'text-center',
            thStyle: 'width: 150px;',
          },
        ],
        records: [],
      },
    };
  },
  computed: {
    ...mapState(['dadosUsuario']),
  },
  watch: {
    'pagination.currentPage': function () {
      this.get();
    },
  },
  mounted() {
    this.get();
  },
  methods: {
    ...mapActions('shopkeeper', ['getSelectedProducts']),
    formattedPriceRules(itens) {
      return itens.map(item => `${item.quantity}/${item.price}`).join(' - ');
    },
    formatUrl(foto) {
      return process.env.VUE_APP_FOTOS_URL+foto;
    },
    linkFotos(origem) {
      if (origem == 'Belenus' || origem == 'fixadores') {
        return 'https://storage.googleapis.com/fotos-prd/';
      }
      return process.env.VUE_APP_FOTOS_URL;
    },
    cleanSelection() {
      this.filters = {};
      this.get();
    },
    filterDate() {
      this.table.records = [];
      this.pagination.currentPage = 1;
      this.pagination.lastPage = 1;
      this.get();
    },
    get() {
      if (this.loading) return;

      if (this.filters.name) {
        this.startDate = '';
        this.endDate = '';
        this.table.records = [];
        this.pagination.currentPage = 1;
      }

      this.loading = true;
      this.$store.dispatch('startLoader');
      
      this.getSelectedProducts({
        userId: this.userTypeId(),
        productName: this.filters.name,
        codInt: this.filters.cod_int,
        currentPage: this.pagination.currentPage,
        familyId: this.filters.family,
        typeProducts: 'geral',
        startDate: this.startDate,
        endDate: this.endDate,
        status: '',
        isPartner: true,
      })
        .then((response) => {
          const { perPage, total, lastPage } = response.data.data || {};
          this.pagination.itemsPerPage = perPage || 15;
          this.pagination.total = total;
          this.pagination.lastPage = lastPage;
          this.table.records = response.data.data.data;
        })
        .finally(() => {
          this.$store.dispatch('endLoader');
          this.loading = false;
        });
    },
    formatMoneyUn(value) {
      if(value.match(/R/)){
        return value;
      } else {
        var money = parseFloat(value);
        return money.toLocaleString('pt-BR', {style: 'currency', currency: 'BRL',});
      }
    },
    formatNumber(number) {
      return Intl.NumberFormat('pt-BR', {
        currency: 'BRL',
        style: 'currency',
      }).format(number);
    },
    validItens(item) {
      if (item != null && item.status == 2) {
        return 'lineDanger';
      }
    },
    userTypeId() {
      return this.$route.meta.userType == UserTypes.BALCONISTA
        ? this.dadosUsuario.construp_user_id
        : this.dadosUsuario.id;
    },
    calcProfit(item, type) {
      if (!item.tar_rate == 0 || item.cost_price == 0) return 0;
      return calculateProfit(
        type, 
        item.priceSalesFormat1, 
        item.cost_price, 
        item.tax_rate,
      );
    },
    showPercentageModal(item) {
      this.$refs.percentagePartnerModal.toggleOpen({
        product:item,
        partners: item.partnerProducts[0],
        title: 'Editar valores produtos',
      });
    },
    async save(item) {
      try {
        this.$store.dispatch('startLoader');
        const { data } = await shopkeeperAppApi.put(
          '/products/partners/update-percentage', item );
        
        if(data.data){
          this.makeToast('sucesso', 'Porcentagem atualizada com sucesso', 'success');
          this.get();
        };
        
        this.$store.dispatch('endLoader');
      } catch (error) {
        this.$store.dispatch('endLoader');
        this.makeToast('error', 'Erro ao vincular produto', 'danger');
      }
    },
  },
};
</script>

<style scoped>
.danger {
  background: rgb(235, 24, 24);
  color: #fff;
  padding: 5px 10px;
  border-radius: 3px;
  cursor: pointer;
}
.imgWidth {
  width: 50px;
  cursor: pointer;
}
.headTable{
  background: white;
  border: none;
  padding: 0;
}
.btn-type-products {
  width: 50%;
  border: 1px solid #ff7f00;
  border-radius: 3px;
  padding: 5px 10px;
  color: #222;
  background-color: transparent;
}
.btn-type-products-selected {
  width: 50%;
  border: 1px solid #ff7f00;
  border-radius: 3px;
  padding: 5px 10px;
  color: #fff;
  background-color: #ff7f00;
}
</style>